import {forwardRef} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {formatMoney} from '../../../../utils'

import TextField from '@mui/material/TextField'



const DECIMAL_INPUT_REGEX = /^[0-9]*\.?[0-9]{0,2}$/


const MoneyField = forwardRef(({
  field: { name, value, onBlur },
  form:  { touched, errors, setFieldValue, isSubmitting },
  // grab these so they don’t end up in …other
  disabled,
  startAdornment,
  innerRef,
  InputProps: incomingInputProps = {},
  // styling props
  sx,
  className,
  css,
  helperText,
  // everything else (label, variant, fullWidth…)
  ...other
}, ref) => {

  const showError = Boolean(touched[name] && errors[name])
  const errorMsg  = errors[name]



  function formatInputToCurrency(e) {
    // strip any non‑digit/dot, cap to two decimals
    let raw = e.target.value.replace(/[^0-9.]/g, '')
    const [intPart, decPart = ''] = raw.split('.')
    const clean = intPart + (decPart ? '.' + decPart.slice(0,2) : '')
    const num   = parseFloat(clean) || 0
    return formatMoney(num).replace('$','')
  }


  const handleChange = e => {
    const val = e.target.value
    if (val === '' || DECIMAL_INPUT_REGEX.test(val)) {
      setFieldValue(name, val)
    }
  }

  const handleBlur = e => {
    onBlur(e)
    setFieldValue(name, formatInputToCurrency(e))
  }


  return (
    <TextField
      // Formik wiring
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      variant='filled'
      
      // error state
      error={showError}
      helperText={showError ? errorMsg : helperText}
      disabled={disabled ?? isSubmitting}

      // forwarded ref
      inputRef={ref || innerRef}

      // styling
      sx={{ fontSize: 16, ...sx }}
      className={className}
      css={css}

      // adornment + any incoming InputProps
      InputProps={{
        startAdornment,
        ...incomingInputProps
      }}

      // everything else (label, variant, fullWidth…)
      {...other}
    />
  )
})


export default MoneyField


